// extracted by mini-css-extract-plugin
export default {"badge":"UserTierBadge_badge__P+uH8"};